import { $ } from '../utils/jquery.js';

// apply coupon code
$(document).on("click", ".js-side-cart-promo-form-toggle", () => {
  $(".js-side-cart-promo-form-wrapper").toggleClass("is-active");
});

// show gift textarea
$(document).on("change", ".js-cart-gift-textarea-trigger", function () {
  const el = $(this);
  const form = el.closest(".gift-message-form");

  if (el.prop("checked")) {
    form.addClass("is-active");
  } else {
    form.removeClass("is-active");
  }
});

// artist page description toggle on mobile
$(document).on(
  "click",
  ".single-artist-banner__info-expand__btn.read-more__btn",
  () => {
    $(".single-artist-banner__info-desc").removeClass(
      "single-artist-banner__collapsible"
    );
    $(".single-artist-banner__info-expand").removeClass(
      "single-artist-banner__info-expand--bg"
    );
    $(".single-artist-banner__info-expand__btn.read-more__btn").hide();
    $(".single-artist-banner__info-expand__btn.read-less__btn").show();
  }
);

$(document).on(
  "click",
  ".single-artist-banner__info-expand__btn.read-less__btn",
  () => {
    $(".single-artist-banner__info-desc").addClass(
      "single-artist-banner__collapsible"
    );
    $(".single-artist-banner__info-expand").addClass(
      "single-artist-banner__info-expand--bg"
    );
    $(".single-artist-banner__info-expand__btn.read-more__btn").show();
    $(".single-artist-banner__info-expand__btn.read-less__btn").hide();
  }
);

$(".pw-atmosphere-card__point-text__dot").click(function () {
  $(this)
    .parent(".pw-atmosphere-card__point-text")
    .find(".pw-atmosphere-card__point-text__box")
    .toggleClass("pw-atmosphere-card__point-text__box--visible");
  // $('.pw-atmosphere-card__point-text__box').toggleClass('pw-atmosphere-card__point-text__box--visible');
});

// $('.pw-atmosphere-card__point-text__dot, .pw-atmosphere-card__point-text').hover(function(){
//   $(this).parent('.pw-atmosphere-card__point-text').find('.pw-atmosphere-card__point-text__box').toggleClass('pw-atmosphere-card__point-text__box--visible');
//   // $('.pw-atmosphere-card__point-text__box').toggleClass('pw-atmosphere-card__point-text__box--visible');
// });
